var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("strong", [_vm._v("Breaks")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "hours-operation__breaks-list" },
      _vm._l(_vm.breaks, function(breakItem, index) {
        return _c("li", { key: index }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.breakStartTime(
                  breakItem.startTime.hour,
                  breakItem.startTime.minute
                )
              ) +
              "\n      for " +
              _vm._s(breakItem.lengthInMin) +
              " minutes\n      "
          ),
          !_vm.disabled
            ? _c(
                "button",
                {
                  staticClass: "cf-node__action m-l-5",
                  on: {
                    click: function($event) {
                      return _vm.removeBreak(index)
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-trash",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            : _vm._e()
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }